import ApiRequest from "./ApiRequest";

function getCampaigns(params) {
  return ApiRequest({
    url: `/campaigns`,
    method: "GET",
    params: params
  });
}

function getCoupons(params) {
  return ApiRequest({
    url: `/coupons`,
    method: "GET",
    params: params
  });
}

function putCampaign(id, data) {
  return ApiRequest({
    url: `/campaigns/${id}`,
    method: "PUT",
    data: data
  });
}

const Api = {
  putCampaign , getCampaigns, getCoupons
};

export default Api;
